import React from "react";
// SCSS
import "./hero.scss";
//Assets
import HeroImage from '../../assets/hero/user.png';
import RockEmoji from '../../assets/hero/RockEmoji.png';

const hero = () => (
  <div className="hero" id="hero">
    <div className="wrapper">
      <div className="hero-info">
        <div className="img-background">
          <img src={HeroImage} alt="" className="hero-image" />
        </div>
        <div className="intro-text">
          <p className="font24">
            Hello, I'm Rusyaidi
          </p>
          <img src={RockEmoji} alt="" />
        </div>
        <h1 className="weight700 font60">
          Develop web application, design high-end web design and coffee lover.
        </h1>


      </div>
    </div>
  </div>
);

export default hero;
